jQuery(function($) {
    $('[aria-required="true"]').attr('required', 'required');
});